import { LayoutGrid, List } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';

interface ViewToggleProps {
  viewMode: 'full' | 'compact';
  onToggle: () => void;
  fullLabel?: string;
  compactLabel?: string;
}

const ViewToggle: React.FC<ViewToggleProps> = ({
  viewMode,
  onToggle,
  fullLabel,
  compactLabel,
}) => {
  const { t } = useTranslation();

  const isFull = viewMode === 'full';
  const label = isFull
    ? fullLabel || t('viewToggle.switchToCompact')
    : compactLabel || t('viewToggle.switchToFull');

  return (
    <Button
      variant="outline"
      size="md"
      onClick={onToggle}
      className="w-12 p-0"
      aria-label={label}
      title={label}
    >
      {isFull ? (
        <LayoutGrid size={34} style={{ width: 34, height: 34 }} strokeWidth={3.25} />
      ) : (
        <List size={34} style={{ width: 34, height: 34 }} strokeWidth={3.25} />
      )}
    </Button>
  );
};

export default ViewToggle;
